import request from '@/utils/request'

// 生成订单
export function addOrder(data) {
  return request({
    url: '/proxyApi/addOrder',
    method: 'post',
    data,
  })
}